import apiClient from '@/api/apiClient'

export const getInboxes = accountId =>
  apiClient.get(`api/v1/accounts/${accountId}/inboxes`)

export const getInbox = (accountId, id) =>
  apiClient.get(`api/v1/accounts/${accountId}/inboxes/${id}`)

export const updateInbox = (accountId, id, payload) =>
  apiClient.patch(`api/v1/accounts/${accountId}/inboxes/${id}`, payload)

export const getAssignableAgents = (accountId, id) =>
  apiClient.get(`api/v1/accounts/${accountId}/inboxes/${id}/assignable_agents`)

export const createTelegramInbox = (accountId, payload) =>
  apiClient.post(`api/v1/accounts/${accountId}/channels/telegram`, {
    telegram: payload,
  })

export const createMaxInbox = (accountId, payload) =>
  apiClient.post(`api/v1/accounts/${accountId}/channels/max`, {
    max: payload,
  })

export const createVkInbox = (accountId, payload) =>
  apiClient.post(`api/v1/accounts/${accountId}/channels/vk`, {
    vk: payload,
  })

export const createWebWidgetInbox = (accountId, payload) =>
  apiClient.post(`api/v1/accounts/${accountId}/channels/web_widget`, {
    web_widget: payload,
  })

export const deleteInbox = (accountId, id) =>
  apiClient.delete(`api/v1/accounts/${accountId}/inboxes/${id}`)

export const uploadBotAvatar = (accountId, id, file) => {
  const form = new FormData()
  form.append('bot_avatar', file)
  return apiClient.post(
    `api/v1/accounts/${accountId}/inboxes/${id}/bot_avatar`,
    form
  )
}

export const removeBotAvatar = (accountId, id) =>
  apiClient.delete(`api/v1/accounts/${accountId}/inboxes/${id}/bot_avatar`)
